module.exports = __webpack_public_path__ + "img/undraw_empty_re_opql.7b0f5341.svg";